import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  semaLandingPage: {
    loading: false,
    error: null,
    data: null,
  },
}

const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState,
  reducers: {
    fetchSemaLandingPageRequest: (state, action) => {
      state.semaLandingPage.loading = true
      state.semaLandingPage.error = null
      state.semaLandingPage.data = null
    },
    fetchSemaLandingPageSuccess: (state, action) => {
      state.semaLandingPage.loading = false
      state.semaLandingPage.error = null
      state.semaLandingPage.data = action.payload
    },
    fetchSemaLandingPageError: (state, action) => {
      state.semaLandingPage.loading = false
      state.semaLandingPage.data = null
      state.semaLandingPage.error = action.payload
    },
    resetSemaLandingPage: (state, action) => {
      state.semaLandingPage.loading = false
      state.semaLandingPage.error = null
      state.semaLandingPage.data = null
    },
  },
})

export const {
  fetchSemaLandingPageRequest,
  fetchSemaLandingPageSuccess,
  fetchSemaLandingPageError,
  resetSemaLandingPage,
} = landingPageSlice.actions

export default landingPageSlice.reducer
